import { Component, Inject, Input, OnInit } from '@angular/core';
import { hd } from '@nx-fe/services';
import { TaskManagerService } from 'app/modules/remote-control/services/task-manager.service';
import { TaskManagerState } from 'app/modules/remote-control/services/taskManagerState';
import { RcContext } from 'app/modules/remote-control-ng/context/rcContext';

@Component({
  selector: 'app-task-details-android',
  templateUrl: './task-details-android.component.html',
  styleUrls: ['./task-details-android.component.scss'],
})
export class TaskDetailsAndroidComponent implements OnInit {
  @Input()
  public deviceKind: string;
  private taskDetails: hd.IAndroidProcessDetails;
  public state: TaskManagerState;
  public androidPackageTableSort: hd.ISortInfo;
  constructor(
    private taskManagerService: TaskManagerService) { }

  ngOnInit() {
    this.state = this.taskManagerService.getState(RcContext.instance.sotiAssistDeviceId) as any;
    if (this.state && this.state.androidProcessDetails) {
      this.taskDetails = this.state.androidProcessDetails;
    }
    this.androidPackageTableSort = this.state.sortInfos[hd.TaskManagerTables.androidPackageTable];
  }

  public sortPackageTableBy(column: string) {
    this.state.sortTableBy(column, this.state.androidProcessDetails.applications, this.androidPackageTableSort);
  }

  public goBack() {
    this.state.inDetailsView = false;
  }
}
